import { render, staticRenderFns } from "./ClinicalCases.vue?vue&type=template&id=03c8ab0c&"
import script from "./ClinicalCases.vue?vue&type=script&lang=js&"
export * from "./ClinicalCases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports